<template>
  <div class="collection-point-data-table">
    <CollectionPointCreateModal ref="collectionPointCreateModal" />
    <CollectionPointDeleteModal ref="collectionPointDeleteModal" />
    <InfiniteLoading
      v-if="filteredArray && filteredArray.length > 0"
      :list="filteredArray"
      :items-per-scroll="20"
      @load-more="loadMore"
      @update-list="updateList"
    />

    <div
      v-if="collectionPointIsLoading"
      class="loading"
    >
      <spinner />
    </div>
    <div v-else>
      <data-table
        v-if="filteredArray && filteredArray.length > 0"
        :header="table.header"
        is-sticky
      >
        <div
          v-for="(collectionPoint, index) in listItems"
          :key="index"
          class="data-table__body__row"
        >
          <data-cell :size="30">
            <p class="name ellipsable">
              {{ collectionPoint.name }}
              <md-tooltip md-direction="top">
                {{ collectionPoint.name }}
              </md-tooltip>
            </p>
          </data-cell>
          <data-cell :size="20">
            <p class="regular">
              <span>{{ collectionPoint.updatedBy }}</span>
              <md-tooltip md-direction="top">
                {{ collectionPoint.updatedBy }}
              </md-tooltip>
            </p>
          </data-cell>
          <data-cell :size="20">
            <p class="regular">
              {{ dateToLocale(collectionPoint.createdAt) }}
            </p>
          </data-cell>
          <data-cell :size="20">
            <p class="regular">
              {{ dateToLocale(collectionPoint.updatedAt) }}
            </p>
          </data-cell>
          <data-cell
            :size="10"
            class="actions-cell"
          >
            <div class="actions-container">
              <div
                class="status-icon icon-edit-alt"
                @click="openCreateModal(collectionPoint)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Editar
                </md-tooltip>
              </div>
              <div
                class="status-icon icon-delete-alt"
                @click="openDeleteModal(collectionPoint)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Excluir
                </md-tooltip>
              </div>
            </div>
          </data-cell>
        </div>
      </data-table>
      <div
        v-if="
          filteredArray && filteredArray.length === 0 && !collectionPointIsLoading
        "
        class="no-results"
      >
        <div class="img-wrapper">
          <img
            src="/static/images/no-file-img.svg"
            alt="sem-resultados"
          >
        </div>
        <p>Nenhum posto de coleta cadastrado.</p>
        <p>Para adicionar postos de coleta, selecione:</p>
        <button @click="openCreateModal()">
          NOVO POSTO DE COLETA
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Moment from 'moment'
import DataTable from '../common/dataTable/DataTable'
import DataCell from '../common/dataTable/DataCell'
import Spinner from '@/components/common/Spinner'
import InfiniteLoading from '@/components/common/InfiniteLoading'

import fuzzysort from 'fuzzysort'

import CollectionPointCreateModal from './CollectionPointCreateModal'
import CollectionPointDeleteModal from './CollectionPointDeleteModal'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CollectionPointList',
  components: {
    DataTable,
    DataCell,
    InfiniteLoading,
    CollectionPointCreateModal,
    CollectionPointDeleteModal,
    Spinner
  },
  props: {
    filterInput: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      table: {
        header: [
          {
            title: 'Posto de coleta',
            subtitle: 'Nome',
            size: 30
          },
          {
            title: 'Adicionado',
            subtitle: 'por',
            size: 20
          },
          {
            title: 'Inclusão',
            subtitle: 'Data',
            size: 20
          },
          {
            title: 'Última alteração',
            subtitle: 'Data',
            size: 20
          },
          {
            title: '',
            subtitle: '',
            size: 10
          }
        ]
      },
      listItems: []
    }
  },
  methods: {
    ...mapActions(['getAllCollectionPointList']),
    ...mapActions(['getServiceAlert']),
    ...mapActions(['getcollectionPointBatches']),
    updateList (newList) {
      this.listItems = newList
    },
    loadMore (items) {
      items.forEach((item) => {
        this.listItems.push(item)
      })
    },
    onInfinite () {
      this.getServiceAlert()
    },
    openCreateModal (collectionPoint) {
      this.$nextTick(function () {
        this.$refs.collectionPointCreateModal.openModal(collectionPoint)
      })
    },
    openDeleteModal (collectionPoint) {
      this.getcollectionPointBatches(collectionPoint.name)
      this.$nextTick(function () {
        this.$refs.collectionPointDeleteModal.openModal(collectionPoint)
      })
    },
    dateToLocale (inputDate) {
      if (inputDate) {
        let dateTime = Moment(inputDate).toDate()
        dateTime = new Date(dateTime)
        dateTime = dateTime.setHours(dateTime.getHours() - 3)
        dateTime = new Date(dateTime)
        const date = dateTime.toLocaleDateString()
        let time = Moment(dateTime).format('HH:mm')
        return date + ' às ' + time
      }
      return ''
    },
    setNormalize (string) {
      return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    }
  },
  computed: {
    ...mapGetters(['collectionPointIsLoading']),
    ...mapGetters(['collectionPoints']),
    filteredArray () {
      if (this.filterInput) {
        if (this.filterInput.length > 0) {
          let inputNormalized = this.setNormalize(this.filterInput)
          if (this.collectionPoints) {
            var targets = this.collectionPoints.map((collectionPoint) => {
              collectionPoint.collecPointNameNormalized = this.setNormalize(
                collectionPoint.name
              )
              return collectionPoint
            })
          }
          let result = fuzzysort.go(inputNormalized, targets, {
            keys: ['collecPointNameNormalized', 'updatedBy'],
            limit: 100,
            allowTypo: true,
            threshold: -10000
          })
          result = result.map((item) => {
            item = item.obj
            return item
          })
          return result
        }
      } else {
        return this.collectionPoints
      }
    }
  },
  mounted () {
    this.getAllCollectionPointList()
  }
}
</script>

<style lang="scss">
.collection-point-data-table {
  .loading {
    min-height: 60vh;
    display: flex;
    align-items: center;
  }
  width: 100%;
  .no-results {
    color: #7a7a7a;
    text-align: center;
    min-height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    .img-wrapper {
      margin-bottom: 35px;
    }
    p {
      font-size: 16px;
      margin-bottom: 20px;
      &:first-of-type {
        font-size: 20px;
      }
    }
    button {
      font-size: 10px;
      color: #fff;
      font-weight: 500;
      background-color: #55cd9e;
      padding: 8px 16px;
      height: auto;
      margin: 10px 0;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .infinite-loading-container {
    min-height: 30vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .name {
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;
    width: 100%;
  }

  .regular {
    font-weight: normal;
    font-size: 14px;
  }

  .actions {
    &-container {
      display: none;

      div {
        margin: 0 0.4em;
      }
    }
    &-cell {
      padding-left: 0;
    }
  }

  .data-table__body__row {
    min-height: 5.5em;
    &__cell {
      display: flex;
    }
    &:hover {
      .actions {
        &-container {
          display: inline-flex;
        }
      }
    }
  }
}
</style>
